import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {MathHelper} from "../../utils/MathHelper";
import {SymbolData} from "./TeslaMainGameBonusController";

/**
 * Created by h3 on 2017-10-12.
 */

export class TeslaBonusSymbolView extends BaseView {

    private _layer:ScalableLayer;
    private _container:PIXI.Container;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.BONUS_OVERLAY.name);
    }

    protected initAnimations():void {
        this._container = new PIXI.Container();
        this._layer.addChild(this._container);
    }

    private createTransformAnimation(fromPosition:PIXI.Point, targetSymbol:SymbolData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const visualWidth = 360;

        const angle = MathHelper.angleBetweenPoints(targetSymbol.position, fromPosition);
        const distance = MathHelper.distanceBetweenPoints(targetSymbol.position, fromPosition);

        const ringElectro = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.SELECTION_CIRCLE_EFFECT));
        ringElectro.x = targetSymbol.position.x;
        ringElectro.y = targetSymbol.position.y;
        ringElectro.hide();
        ringElectro.blendMode = PIXI.BLEND_MODES.ADD;
        ringElectro.anchor.set(0.5, 0.5);
        this._container.addChild(ringElectro);

        const lightningEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.LIGHTNING_EFFECT));
        lightningEffect.width = distance * (lightningEffect.width / visualWidth);
        lightningEffect.position.set(fromPosition.x, fromPosition.y);
        lightningEffect.rotation = angle;
        lightningEffect.blendMode = PIXI.BLEND_MODES.ADD;
        lightningEffect.hide();
        lightningEffect.anchor.set(0.874, 0.555);
        this._container.addChild(lightningEffect);

        tl.add([
            lightningEffect.getAnimationAutoShowHide(true, true),
            ringElectro.getAnimationAutoShowHide(true, true),
        ]);

        tl.add(() => targetSymbol.symbol!.replaceWith(ReelSymbolName.WILD, targetSymbol.symbol!.reelId));

        return tl;

    }

    public getTransformAnimations(fromPosition:PIXI.Point, targetSymbols:SymbolData[]) {
        let transformAnimations:TimelineLite[] = [];
        for(let i:number = 0; i < targetSymbols.length; i++) {
            transformAnimations.push(this.createTransformAnimation(fromPosition, targetSymbols[i]));
        }
        return transformAnimations;
    }

    public resetBonusSymbolView() {
        this._container.removeChildren();
    }
}